module.exports = __webpack_public_path__ + "static/media/stepCircle.709e1c09.svg";